export enum VideoIssueModals {
  VideoProblemsWithDevice,
  DeviceInUse,
  VideoSignalDegraded,
  AudioVideoFailure,
  RefreshNeeded
}
